import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "preview-visual"
  }, [_vm.showVisualization ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": _vm.getVisualCols()
    }
  }, [!_vm.hideSelection && _vm.getDropdownItems ? _c(VSelect, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.getDropdownItems,
      "value": _vm.lclModel.properties.visual.type || null,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.componentSelect'),
      "data-cy": "visualization-type-select"
    },
    on: {
      "change": _vm.onVisualChanged
    }
  }) : _vm._e(), _vm.lclModel.properties.valueType === 'boolean' && !_vm.lclModel.properties.visual.type ? _c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "10",
      "sm": "9"
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.state')) + " true")])]), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex mb-3"
  }, [_c(VTextField, {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.states.title')} true`,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.firstStateTitle,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "firstStateTitle", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.firstStateTitle"
    }
  }), _c('div', [_c('core-icons', {
    staticClass: "mr-2 input-width",
    attrs: {
      "faStyle": "light",
      "dense": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.firstFaIcon,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "firstFaIcon", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.firstFaIcon"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iconText')) + "\n                  ")])], 1), _c(VSelect, {
    staticClass: "input-width",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "background-color": _vm.lclModel.properties.visual.options.boolVisual.firstColor,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.colorScheme'),
      "items": [{
        text: 'default',
        value: ''
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightGreen'),
        value: '#7cb342'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.red'),
        value: '#ff1744'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.orange'),
        value: '#fb8c00'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.yellow'),
        value: '#fec60a'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkGreen'),
        value: '#388e3c'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightBlue'),
        value: '#40c4ff'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkBlue'),
        value: '#0091ea'
      }],
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.firstColor,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "firstColor", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.firstColor"
    }
  })], 1), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.state')) + " false")])]), _c('div', {
    staticClass: "d-flex"
  }, [_c(VTextField, {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.states.title')} false`,
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.secondStateTitle,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "secondStateTitle", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.secondStateTitle"
    }
  }), _c('div', [_c('core-icons', {
    staticClass: "mr-2 input-width",
    attrs: {
      "faStyle": "light",
      "dense": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.secondFaIcon,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "secondFaIcon", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.secondFaIcon"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iconText')) + "\n                  ")])], 1), _c(VSelect, {
    staticClass: "input-width",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "background-color": _vm.lclModel.properties.visual.options.boolVisual.secondColor,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.colorScheme'),
      "items": [{
        text: 'default',
        value: ''
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.red'),
        value: '#ff1744'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.orange'),
        value: '#fb8c00'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.yellow'),
        value: '#fec60a'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightGreen'),
        value: '#7cb342'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkGreen'),
        value: '#388e3c'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightBlue'),
        value: '#40c4ff'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkBlue'),
        value: '#0091ea'
      }],
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.properties.visual.options.boolVisual.secondColor,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options.boolVisual, "secondColor", $$v);
      },
      expression: "lclModel.properties.visual.options.boolVisual.secondColor"
    }
  })], 1)])]), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "2",
      "sm": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center h-full",
    attrs: {
      "transition": "fade-transition"
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.boolVisualFaIconColor,
      "x-large": ""
    }
  }, [_vm._v("fal fa-" + _vm._s(_vm.boolVisualFaIcon))]), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.boolVisualStateTitle))])], 1)])], 1) : _vm._e(), _vm.lclModel.properties.visual.type === 'odometer' && !_vm.isBooleanType ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.minLength'),
      "rules": _vm.requiredRule,
      "required": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.valueFieldEdited
    },
    model: {
      value: _vm.lclModel.properties.visual.options.minimumLength,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "minimumLength", $$v);
      },
      expression: "lclModel.properties.visual.options.minimumLength"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.decimalPoints'),
      "rules": _vm.requiredRule,
      "required": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.valueFieldEdited
    },
    model: {
      value: _vm.lclModel.properties.visual.options.decimalPoints,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "decimalPoints", $$v);
      },
      expression: "lclModel.properties.visual.options.decimalPoints"
    }
  })], 1)], 1)] : _vm._e(), _vm.lclModel.properties.visual.type === 'gauge' && !_vm.isBooleanType ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.minValue'),
      "hide-details": "",
      "data-cy": "visualization-gauge-min"
    },
    on: {
      "change": _vm.valueFieldEdited,
      "input": _vm.validateThresholds
    },
    model: {
      value: _vm.lclModel.properties.visual.options.min,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "min", $$v);
      },
      expression: "lclModel.properties.visual.options.min"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.maxValue'),
      "hide-details": "",
      "data-cy": "visualization-gauge-max"
    },
    on: {
      "change": _vm.valueFieldEdited,
      "input": _vm.validateThresholds
    },
    model: {
      value: _vm.lclModel.properties.visual.options.max,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "max", $$v);
      },
      expression: "lclModel.properties.visual.options.max"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.tresholdRule],
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.thresholds'),
      "hide-details": "auto",
      "data-cy": "visualization-gauge-thresholds"
    },
    on: {
      "change": _vm.valueFieldEdited,
      "input": _vm.validateThresholds
    },
    model: {
      value: _vm.lclModel.properties.visual.options.thresholds,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "thresholds", $$v);
      },
      expression: "lclModel.properties.visual.options.thresholds"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "sm": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.decimalPoints'),
      "type": "number",
      "rules": _vm.decimalRules,
      "min": "0",
      "max": "10"
    },
    on: {
      "change": _vm.valueFieldEdited
    },
    model: {
      value: _vm.lclModel.properties.visual.options.decimalPoints,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties.visual.options, "decimalPoints", $$v);
      },
      expression: "lclModel.properties.visual.options.decimalPoints"
    }
  })], 1)], 1), _c(VRow, _vm._l(_vm.lclModel.properties.visual.options.thresColors, function (item, i) {
    return _c(VCol, {
      key: i,
      staticStyle: {
        "min-width": "120px"
      },
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c(VSelect, {
      staticStyle: {
        "font-size": "12px"
      },
      attrs: {
        "disabled": _vm.mode === 'readonly',
        "background-color": item,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "items": [{
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.red'),
          value: '#ff1744'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.orange'),
          value: '#fb8c00'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.yellow'),
          value: '#fec60a'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightGreen'),
          value: '#7cb342'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkGreen'),
          value: '#388e3c'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.lightBlue'),
          value: '#40c4ff'
        }, {
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.colors.darkBlue'),
          value: '#0091ea'
        }],
        "dense": "",
        "hide-details": "",
        "data-cy": `visualization-gauge-color-select-${i}`
      },
      on: {
        "change": _vm.valueFieldEdited
      },
      model: {
        value: _vm.lclModel.properties.visual.options.thresColors[i],
        callback: function ($$v) {
          _vm.$set(_vm.lclModel.properties.visual.options.thresColors, i, $$v);
        },
        expression: "lclModel.properties.visual.options.thresColors[i]"
      }
    })], 1);
  }), 1)] : _vm._e(), _vm.lclModel.properties.visual.type === 'lineChart' ? [_c(VForm, {
    ref: "stateHistoryForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "sm": "12"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.items,
      "disabled": _vm.rawData || _vm.mode === 'readonly',
      "item-text": "time",
      "item-value": "timeVal",
      "single-line": "",
      "label": _vm.$i18n_t('Common.chartOptions.interval'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.interval,
      callback: function ($$v) {
        _vm.interval = $$v;
      },
      expression: "interval"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "8",
      "sm": "12"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": [{
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastMinutes', 5, {
          n: 5
        }),
        value: 'now-5m'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastMinutes', 15, {
          n: 15
        }),
        value: 'now-15m'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastMinutes', 30, {
          n: 30
        }),
        value: 'now-30m'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastHours', 1, {
          n: 1
        }),
        value: 'now-1h'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastHours', 2, {
          n: 2
        }),
        value: 'now-2h'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastHours', 6, {
          n: 6
        }),
        value: 'now-6h'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastHours', 12, {
          n: 12
        }),
        value: 'now-12h'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastHours', 24, {
          n: 24
        }),
        value: 'now-24h'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastDays', 2, {
          n: 2
        }),
        value: 'now-2d'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastDays', 7, {
          n: 7
        }),
        value: 'now-7d'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastDays', 30, {
          n: 30
        }),
        value: 'now-30d'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastDays', 90, {
          n: 90
        }),
        value: 'now-90d'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastMonths', 6, {
          n: 6
        }),
        value: 'now-6M'
      }, {
        text: _vm.$i18n_tc('Core.DateTimePicker.rangeItems.relative.lastYears', 1, {
          n: 1
        }),
        value: 'now-1y'
      }],
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": "Time span",
      "hide-details": "auto"
    },
    on: {
      "change": _vm.setTimeSpan
    },
    model: {
      value: _vm.queryTimeSpan,
      callback: function ($$v) {
        _vm.queryTimeSpan = $$v;
      },
      expression: "queryTimeSpan"
    }
  })], 1), _c(VCol, {
    staticClass: "d-flex justify-space-between",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('latest') || _vm.isBooleanType || _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.latest'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.latest,
      callback: function ($$v) {
        _vm.latest = $$v;
      },
      expression: "latest"
    }
  }), _c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('min') || _vm.isBooleanType || _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.min'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.min,
      callback: function ($$v) {
        _vm.min = $$v;
      },
      expression: "min"
    }
  }), _c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('max') || _vm.isBooleanType || _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.max'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.max,
      callback: function ($$v) {
        _vm.max = $$v;
      },
      expression: "max"
    }
  }), _c(VCheckbox, {
    attrs: {
      "disabled": _vm.shouldOptionCheckboxBeDisabled('average') || _vm.isBooleanType || _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.average'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.average,
      callback: function ($$v) {
        _vm.average = $$v;
      },
      expression: "average"
    }
  })], 1), _c(VCol, {
    staticClass: "d-flex justify-space-between",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.raw'),
      "color": _vm.color,
      "hide-details": "",
      "inset": ""
    },
    model: {
      value: _vm.rawData,
      callback: function ($$v) {
        _vm.rawData = $$v;
      },
      expression: "rawData"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-start"
  }, [_c(VTextField, {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.yAxisMin'),
      "hide-details": "",
      "rules": _vm.yAxisRules
    },
    model: {
      value: _vm.minYAxis,
      callback: function ($$v) {
        _vm.minYAxis = _vm._n($$v);
      },
      expression: "minYAxis"
    }
  }), _c(VTextField, {
    staticClass: "mr-0",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.yAxisMax'),
      "hide-details": "",
      "rules": _vm.yAxisRules
    },
    model: {
      value: _vm.maxYAxis,
      callback: function ($$v) {
        _vm.maxYAxis = _vm._n($$v);
      },
      expression: "maxYAxis"
    }
  })], 1)])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-start"
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "label": _vm.$i18n_t('Common.chartOptions.chartlines'),
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.chartLinesCurved,
      callback: function ($$v) {
        _vm.chartLinesCurved = $$v;
      },
      expression: "chartLinesCurved"
    }
  }), _c(VCheckbox, {
    staticClass: "mt-0 ml-3",
    attrs: {
      "label": _vm.$i18n_t('Common.chartOptions.chartOmitNull'),
      "color": _vm.color,
      "hide-details": "",
      "disabled": _vm.isBooleanType || _vm.mode === 'readonly'
    },
    model: {
      value: _vm.chartOmitNull,
      callback: function ($$v) {
        _vm.chartOmitNull = $$v;
      },
      expression: "chartOmitNull"
    }
  }), _c(VSelect, {
    attrs: {
      "items": _vm.spanItems,
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.chartOptions.chartWidth'),
      "hide-details": ""
    },
    model: {
      value: _vm.span,
      callback: function ($$v) {
        _vm.span = $$v;
      },
      expression: "span"
    }
  })], 1)])], 1)], 1)] : _vm._e(), _c('p', {
    staticClass: "card-description ma-0 p-0"
  }, [_vm._v("\n          " + _vm._s(_vm.helpText || _vm.$i18n_t(`DigitalTwin.DigitalTwin.visualization.help.${_vm.lclModel.properties.visual.type || 'none'}`)) + "\n        ")])], 2), !_vm.hidePreview && _vm.lclModel.properties.visual.type !== 'null' ? _c(VCol, {
    attrs: {
      "cols": _vm.lclModel.properties.visual.type === 'lineChart' ? 6 : 3
    }
  }, [_c('div', {
    staticClass: "ma-0",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.lclModel.properties.visual.type === 'gauge' && !_vm.isBooleanType ? [_c('core-chart-gauge-modern', {
    key: _vm.updateVisual,
    attrs: {
      "size": 160,
      "min": parseFloat(_vm.lclModel.properties.visual.options.min) || 0,
      "max": parseFloat(_vm.lclModel.properties.visual.options.max) || 0,
      "unit": _vm.lclModel.unit,
      "value": parseFloat(_vm.lclModel.value.value),
      "thresholds": _vm.sanitizeThresholds(_vm.lclModel.properties.visual.options.thresholds),
      "reverse": _vm.lclModel.properties.visual.options.reverse,
      "thresholdColors": _vm.lclModel.properties.visual.options.thresColors,
      "fixTo": _vm.getDecimalPoints(_vm.lclModel.properties.visual.options.decimalPoints)
    }
  })] : _vm._e(), _vm.lclModel.properties.visual.type === 'doughnut' && !_vm.isBooleanType ? [_c('core-chart-doughnut', {
    key: _vm.updateVisual,
    attrs: {
      "size": 160,
      "thickness": 20,
      "value": parseFloat(_vm.lclModel.value.value)
    }
  })] : _vm._e(), _vm.lclModel.properties.visual.type === 'odometer' && !_vm.isBooleanType ? [_c('core-chart-odometer', {
    key: _vm.updateVisual,
    attrs: {
      "size": 160,
      "minLength": parseFloat(_vm.lclModel.properties.visual.options.minimumLength),
      "fixTo": parseFloat(_vm.lclModel.properties.visual.options.decimalPoints),
      "value": parseFloat(_vm.lclModel.value.value)
    }
  })] : _vm._e(), _vm.lclModel.properties.visual.type === 'battery' && !_vm.isBooleanType ? [_c('core-chart-battery', {
    key: _vm.updateVisual,
    attrs: {
      "size": 160,
      "value": parseFloat(_vm.lclModel.value.value)
    }
  })] : _vm._e(), _vm.lclModel.properties.visual.type === 'lineChart' ? [_c('div', {
    staticClass: "relative"
  }, [_c('core-chart-history-state-line', {
    class: {
      'chart-empty': _vm.isEmptyChart(_vm.chartData)
    },
    attrs: {
      "chart-data": _vm.chartData,
      "interval": _vm.interval,
      "height": 160,
      "width": 400,
      "hideLegend": "",
      "config": _vm.chartConfig,
      "minYAxis": _vm.minYAxis,
      "maxYAxis": _vm.maxYAxis
    }
  }), _vm.isEmptyChart(_vm.chartData) ? _c('div', {
    staticClass: "chart-empty-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")]) : _vm._e(), _vm.hasChartError ? _c('div', {
    staticClass: "chart-empty-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.errorWhileFetchingData')) + "\n              ")]) : _vm._e()], 1)] : _vm._e()], 2)]) : _vm._e()], 1)] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };